<template>
    <UserPageLayout>
        <div class="max-w-md mx-auto pt-12">
            <div v-if="status !== ''" class="bg-white rounded shadow-lg relative">
                <InnerLoader v-if="isLoading" class="rounded" :z-index="999" />
                <div class="px-5 py-6">
                    <div class="text-center">
                        <i
                            :class="{
                                'far text-6xl': true,
                                'fa-check-circle text-green': status == 'success',
                                'fa-times-circle text-red': status == 'fail'
                            }"
                        ></i>
                    </div>
                    <div class="text-center">
                        <h1 v-if="status == 'success'" class="text-3xl shadow-text-none">
                            {{ $t('confirm_email_header_success') }}
                        </h1>
                        <h1 v-if="status == 'fail'" class="text-3xl shadow-text-none">
                            {{ $t('confirm_email_header_fail') }}
                        </h1>

                        <p class="pb-6">
                            <span
                                v-if="status == 'success'"
                                class="shadow-text-none"
                                v-html="$t('confirm_email_text_success')"
                            ></span>
                            <span
                                v-if="status == 'fail'"
                                class="shadow-text-none"
                                v-html="$t('confirm_email_text_fail')"
                            ></span>
                        </p>
                    </div>
                    <div class="text-center mt-3">
                        <router-link :to="{ name: 'my-quiz' }" class="btn btn-lg text-xl uppercase font-opensans">{{
                            $t('confirm_email_go_myquiz')
                        }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import InnerLoader from '@/components/InnerLoader'
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import { currentUser } from '@/lib/user.js'

export default {
    components: {
        UserPageLayout,
        InnerLoader
    },

    data() {
        return {
            status: '',
            isLoading: false
        }
    },

    mounted() {
        this.$store.commit('toggleMainLoader', false)

        this.checkConfirmStatus(currentUser().id, this.$route.params.token)
    },

    methods: {
        afterLoginSuccess() {
            this.$router.go()
        },

        checkConfirmStatus(id, token) {
            const request = new Request()
            this.isLoading = true

            let formData = {
                id: id,
                token: token
            }

            request
                .post(appConfig.api.confirmEmail, formData)
                .then(res => {
                    if (res.data.data.is_confirm_email) {
                        this.status = 'success'
                        localStorage.setItem('is_confirm_email_' + currentUser().id, true)
                    } else {
                        this.$router.replace({
                            name: 'my-quiz'
                        })
                    }
                    this.isLoading = false
                })
                .catch(() => {
                    this.status = 'fail'
                    this.isLoading = false
                })
        }
    }
}
</script>
